import { ReactElement } from 'react';

import { IProps } from './types';
import * as S from './styles';

export function SliceExerpt({ slice: { primary } }: IProps): ReactElement {
  return (
    <S.Wrapper className="slice-item slice-exerpt">
      <p>{primary?.text}</p>
    </S.Wrapper>
  );
}

SliceExerpt.componentName = 'excerpt';
